import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {HashLocationStrategy, LocationStrategy} from "@angular/common";
import {PlanningRegionComponent} from "./layout/pages/planning-region/planning-region.component";
import {HomeComponent} from "./layout/pages/home/home.component";


const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
    data: { title: "home.title" }
  },
  {
    path: "planning-region/:id_region/:cookies",
    component: PlanningRegionComponent,
    canActivate: []
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }]
})
export class AppRoutingModule {}
